<ng-container *ngIf="dropdownMode; else inlineModeTpl">
	<button
		mat-button
		#submenuTrigger="matMenuTrigger"
		[matMenuTriggerFor]="submenu"
		(menuOpened)="opened = true"
		(menuClosed)="opened = false"
	>
		<ng-container *ngTemplateOutlet="btnContentTpl"></ng-container>
	</button>

	<mat-menu #submenu="matMenu" backdropClass="{{ popupClassPrefix }}-submenu-backdrop">
		<ng-container *ngTemplateOutlet="submenuContentTpl"></ng-container>
	</mat-menu>
</ng-container>

<ng-template #inlineModeTpl>
	<button mat-button (click)="opened = !opened">
		<ng-container *ngTemplateOutlet="btnContentTpl"></ng-container>
	</button>

	<div *ngIf="opened" @slide>
		<ng-container *ngTemplateOutlet="submenuContentTpl"></ng-container>
	</div>
</ng-template>

<ng-template #btnContentTpl>
	<span class="v-align-baseline">{{ itemName }}</span>

	<bp-svg-icon name="arrow-drop-down" class="bp-icon-md" [class.opened]="opened"></bp-svg-icon>
</ng-template>

<ng-template #submenuContentTpl>
	<div class="{{ popupClassPrefix }}-submenu-content submenu-content">
		<ng-content></ng-content>
	</div>
</ng-template>
